export const getSearchParams = () =>
  new URLSearchParams(window.location.search);

export const updateSearchParams = (params: URLSearchParams) => {
  const newUrl = new URL(window.location.href);
  newUrl.search = params.toString();
  window.history.pushState({}, "", newUrl);
};

export const applySearchParamsToPath = (
  path: string,
  extraParams: Record<string, string | null> = {},
) => {
  const searchParams = getSearchParams();
  for (const [key, value] of Object.entries(extraParams)) {
    if (value === null) searchParams.delete(key);
    else searchParams.set(key, value);
  }
  try {
    // Try to handle as absolute URL
    const newUrl = new URL(path);
    newUrl.search = searchParams.toString();
    return newUrl.toString();
  } catch {
    // Handle as relative URL
    const hasParams = path.includes("?");
    const separator = hasParams ? "&" : "?";
    return `${path}${separator}${searchParams.toString()}`;
  }
};

export const buildQueryParamsString = (
  params: Record<string, string | string[] | undefined>,
): string => {
  const searchParams = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    if (Array.isArray(value)) {
      for (const v of value) {
        searchParams.append(key, v);
      }
    } else if (value !== undefined) {
      searchParams.append(key, value);
    }
  }

  return searchParams.toString();
};
